<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderClientSlim :project="project" />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>5. {{ $t('installationLocationWithInverterAndMateboxState') }}</h2>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('installationLocationWithInverterAndMateboxState') }}</div>
        <div>{{ $t(project.serviceReport.installationLocationWithInverterAndMateboxState) }}</div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('cablePathDistance') }}</div>
        <div>{{ $t(project.serviceReport.cablePathDistance) }}</div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('cableSelection') }}</div>
        <div>{{ $t(project.serviceReport.cableSelection) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.serviceSecondaryInstallationLocationAttachments"
      fieldName="serviceSecondaryInstallationLocationAttachments"
      :maxImages="2"
    />
    <AttachmentsPrintGrid
      :attachments="project.serviceCablePath360Attachments"
      fieldName="serviceCablePath360Attachments"
      :maxImages="2"
    />
    <AttachmentsPrintGrid
      :attachments="project.serviceOpenMatebox"
      fieldName="serviceOpenMatebox"
      :maxImages="2"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderClientSlim from '@/components/Print/PrintHeaderClientSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'InstallationPrintPage',
  components: {
    PrintPage,
    PrintHeaderClientSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
